var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Store } from '@ngrx/store';
import { AppConfigService } from '@app/core/services/app-config-service';
import { LayoutActions } from '@app/core/actions';
export class PrintService {
    /**
     *Creates an instance of PrintService.
     * @param {Store<fromOrderOperation.State>} store
     * @memberof PrintService
     */
    constructor(store) {
        this.store = store;
        /**
         * Abort flag if printing fails
         *
         * @type {boolean}
         * @memberof PrintService
         */
        this.abort = false;
    }
    /**
     * Print sticker to zebra printer
     *
     * @param {string[]} stickers
     * @memberof PrintService
     */
    printStickersOnDefaultDevice(stickers) {
        return __awaiter(this, void 0, void 0, function* () {
            this.abort = false;
            for (let stickerString of stickers) {
                yield this.printDelay(Number.parseInt(AppConfigService.config.App.PrintDelay)).then(() => __awaiter(this, void 0, void 0, function* () {
                    if (!this.abort) {
                        BrowserPrint.getDefaultDevice('printer', (device) => {
                            try {
                                if (!this.abort) {
                                    device.send(stickerString, function (response) { }, (error_response) => {
                                        if (!this.abort) {
                                            this.store.dispatch(new LayoutActions.StickerPrintFailed(stickers));
                                            this.abort = true;
                                        }
                                    });
                                }
                            }
                            catch (_a) { }
                        }, (error_response) => {
                            if (!this.abort) {
                                this.store.dispatch(new LayoutActions.StickerPrintFailed(stickers));
                                this.abort = true;
                            }
                        });
                    }
                }));
            }
        });
    }
    /**
     * Delay printer, This way we keep the order printing outcome equals to the income order
     *
     * @param {number} ms
     * @memberof PrintService
     */
    printDelay(ms) {
        return __awaiter(this, void 0, void 0, function* () {
            yield new Promise(resolve => setTimeout(() => resolve(), ms));
        });
    }
}
